import React from 'react'
import mute from '../../assets/images/player/mute.svg'
import volume33 from '../../assets/images/player/volume33.svg'
import volume66 from '../../assets/images/player/volume66.svg'
import volume100 from '../../assets/images/player/volume100.svg'

function SongVolume() {
  
  function changeSongVolume() {
    let currentSong = document.getElementById(`player-source`),
        volumeIcon = document.getElementById(`song-volume`)
    
    if (currentSong.volume === 0.45) {
      currentSong.volume = 0
      volumeIcon.style.maskImage = `url(${mute})`
      volumeIcon.style.WebkitMaskImage = `url(${mute})`
    } else if (currentSong.volume === 0) {
      currentSong.volume = 0.15
      volumeIcon.style.maskImage = `url(${volume33})`
      volumeIcon.style.WebkitMaskImage = `url(${volume33})`
    } else if (currentSong.volume === 0.15) {
      currentSong.volume = 0.30
      volumeIcon.style.maskImage = `url(${volume66})`
      volumeIcon.style.WebkitMaskImage = `url(${volume66})`
    } else {
      currentSong.volume = 0.45
      volumeIcon.style.maskImage = `url(${volume100})`
      volumeIcon.style.WebkitMaskImage = `url(${volume100})`
    }
  }
  
  return (
    <button id={`song-volume`} onClick={changeSongVolume} style={{maskImage: `url(${volume66})`, WebkitMaskImage: `url(${volume66})`}}>Volume</button>
  )
}

export default SongVolume